module.exports = __webpack_public_path__ + "static/img/02yun.26970177.gif";